import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CreditCard, Building2, Truck, Code, Cloud, Brain, ArrowRight } from 'lucide-react';
import './Services.css';

const Services = () => {
  const { services } = useSelector((state) => state.services);
  const navigate = useNavigate();

  const getIcon = (iconName) => {
    const icons = {
      CreditCard: <CreditCard size={32} />,
      Building2: <Building2 size={32} />,
      Truck: <Truck size={32} />,
      Code: <Code size={32} />,
      Cloud: <Cloud size={32} />,
      Brain: <Brain size={32} />
    };
    return icons[iconName] || <Code size={32} />;
  };

  // Fix: Define scrollToContact function
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="services section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive software solutions and IT services tailored to your business needs
          </p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="service-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="service-icon">
                {getIcon(service.icon)}
              </div>
              
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              
              <div className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <span key={featureIndex} className="feature-tag">
                    {feature}
                  </span>
                ))}
              </div>
              
              <div className="service-action">
                <button
                  className="learn-more-btn"
                  onClick={scrollToContact}
                >
                  Learn More
                  <ArrowRight size={16} />
                </button>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="services-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <h3>Ready to Transform Your Business?</h3>
          <p>Let's discuss how our expertise can help you achieve your goals</p>
          <button 
            className="btn btn-primary"
            onClick={scrollToContact}
          >
            Get In Touch
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
